<ng-container>
  <div class="category-image">
    <img
      [ngSrc]="category().cover?.defaultUrl || ''"
      [alt]="category().title | trans"
      fill
    />
  </div>

  <div class="category-content">
    <div class="category-title">{{ category().title | trans }}</div>

    <div
      [innerHTML]="category().shortDescription | trans"
      class="category-description"
    ></div>
  </div>
</ng-container>
